import { TipoSexo } from '../shared/enums/tipo-sexo.enum';
import { StatusColaborador } from '../shared/enums/status-colaborador.enum';
import { Cartao } from './cartao';
import { CartaoPeriodoPadrao } from '../shared/enums/cartao-periodo-padrao.enum';

export class Colaborador {
    public toDelete: boolean;
    public selected: boolean;
    public esporadico = false;
    public cartao: Cartao;
    public statusApp: any;
    collaboratorId: number;
    collaborators: any;
    document: any;
    costCenter: string;
    unity: string;
    department: string;
    hasApp: any;
    hasCard: any;
    cardID: number;
    registry: string;
    public accounts: Cartao[];
    name: string;
    assignorContractId: number;
    cardId: number;
    standardValue: number;
    standardPeriodId: CartaoPeriodoPadrao;
    standardPeriod: string;
    suspenso: boolean;
    conductor: boolean = false;
    portador: boolean = false;
    suspensaoInicio: any;
    suspensaoFim: any;
    cnh: string;

    constructor(
        public colaboradorId: number,
        public cedenteGuid: string,
        public email: string,
        public nome: string,
        public sobrenome: string,
        public documento: string,
        public dataNascimento: any,
        public sexo: TipoSexo,
        public matricula: string,
        public nomeMae: string,
        public nomePai: string,
        public celular: string,
        public status: StatusColaborador,
        public gestorGuidCadastro: string,
        public gestorGuidAlteracao: string,
        public dataCadastro: Date,
        public dataAlteracao: Date,
        public centroCustoId: number,
        public unidadeId: number,
        public departamentoId: number,
        public nomeCentroCusto: string,
        public nomeUnidade: string,
        public nomeDepartamento: string,
        public apelido: string,
        public pessoaIdColaborador: number,
        public pessoaGuid: string,
        public temCartao: boolean,
        public tipoColaborador: number,
        public pessoaCadastro: string,
        public pessoaAlteracao: string
    ) { }
}

export class CollaboratorAddress{
    cep: string;
    address: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    uf: string
}
